import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/store/store';
import { fetchAllEmployees } from '../model';

export const useEmployees = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchAllEmployees());
  }, [dispatch]);
  const employees = useAppSelector((state) => state.employees.employees);
  return employees;
};
